/**
 * UI threshold constants for consistent behavior across components
 */

export const THINKING_THRESHOLDS = {
  /** Characters before showing expand-to-panel button */
  EXPAND_CHARS: 500,
  /** Paragraph count before showing expand-to-panel button */
  EXPAND_PARAGRAPHS: 3,
} as const

export const CONTENT_THRESHOLDS = {
  /** Characters before user message collapses */
  LONG_MESSAGE_LENGTH: 500,
} as const
